import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5010/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('eugenial_token');
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
});

export default api;
